import { render, staticRenderFns } from "./ItemUpdate.vue?vue&type=template&id=fbb3de98"
import script from "./ItemUpdate.vue?vue&type=script&lang=js"
export * from "./ItemUpdate.vue?vue&type=script&lang=js"
import style0 from "./ItemUpdate.vue?vue&type=style&index=0&id=fbb3de98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports